<form *ngIf="form" [formGroup]="form" class="checkout-form">
  <h2>Address information</h2>

  <div class="pt-2" *ngIf="environment.mockSignup">
    <button type="button" (click)="fillMockAddress()"
      class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
      Fill with Mock Data
    </button>
  </div>

  <div>
    <label class="block text-sm font-medium text-gray-700 mb-1">{{ textService.getText('form_label_street') }}</label>
    <input type="text" formControlName="street"
      class="w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-2" />
    <div *ngIf="form.get('street')?.touched && form.get('street')?.invalid" class="text-red-500 text-xs mt-1">{{
      textService.getText('form_validate_street_format') }}
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">{{ textService.getText('form_label_country')
        }}</label>
      <select id="country" formControlName="country"
        class="w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring focus:ring-blue-500">
        <option value="">-- Select --</option>
        <option *ngFor="let country of countries" [value]="country.value">
          {{ country.label }}
        </option>
      </select>
      <div *ngIf="form.get('country')?.touched && form.get('country')?.invalid" class="text-red-500 text-xs mt-1">{{
        textService.getText('form_validate_country') }}
      </div>
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">{{ textService.getText('form_label_state') }}</label>
      <select id="state" formControlName="state"
        class="w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed">
        <option value="" disabled>-- Select --</option>
        <option *ngFor="let state of states" [value]="state.value">
          {{ state.label }}
        </option>
      </select>
      <div *ngIf="form.get('state')?.touched && form.get('state')?.invalid" class="text-red-500 text-xs mt-1">{{
        textService.getText('form_validate_state') }}
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">{{ textService.getText('form_label_city') }}</label>
      <input type="text" formControlName="city"
        class="w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-2" />
      <div *ngIf="form.get('city')?.touched && form.get('city')?.invalid" class="text-red-500 text-xs mt-1">{{
        textService.getText('form_validate_city_format') }}
      </div>
    </div>

    <div *ngIf="selectedCountry?.hasZipCode !== false">
      <label class="block text-sm font-medium text-gray-700 mb-1" for="postalCode">{{
        textService.getText('form_label_postal_code') }}</label>
      <input id="postalCode" type="text" formControlName="postalCode"
        class="w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-2" />
      <div *ngIf="form.get('postalCode')?.touched && form.get('postalCode')?.invalid" class="text-red-500 text-xs mt-1">
        {{ textService.getText('form_validate_postal_code') }}
      </div>
    </div>
  </div>

  <app-error-banner></app-error-banner>

  <div id="captcha-container">
    <re-captcha
      #captchaRef
      size="invisible"
      badge="bottomleft"
      errorMode="handled"
      (resolved)="onCaptchaResolved($event)">
    </re-captcha>
  </div>
</form>
